<mat-form-field
    appearance="outline"
    class="w-full"
    [class]="showErrorMessage() === true ? '' : '!-mb-[1.25em]'"
    [ngClass]="{
        'read-only': readOnly,
    }"
>
    @if (params.mask) {
        <input
            matInput
            #inputElement
            title="{{ params.title }}"
            placeholder="{{ params.placeholder }}"
            required="{{ params.required }}"
            type="{{ params.type }}"
            tabindex="0"
            [formControl]="formControl"
            [className]="params.classList"
            [showMaskTyped]="params.mask.showMaskTyped"
            [specialCharacters]="params.mask.specialCharacters"
            [dropSpecialCharacters]="params.mask.dropSpecialCharacters ?? true"
            [placeHolderCharacter]="params.mask.placeHolderCharacter"
            [shownMaskExpression]="params.mask.shownMaskExpression"
            [leadZeroDateTime]="params.mask.leadZeroDateTime ?? false"
            [mask]="params.mask.mask"
            (focusout)="
                params.onFocusout ? params.onFocusout(formControl) : null
            "
        />
    } @else if (params.imask) {
        <input
            matInput
            #inputElement
            title="{{ params.title }}"
            [formControl]="formControl"
            [imask]="readOnly ? null : params.imask"
            (focusout)="
                params.onFocusout ? params.onFocusout(formControl) : null
            "
            [className]="params.classList"
            minlength="{{ params.minLength }}"
            maxlength="{{ params.maxLength }}"
            [readonly]="params.readOnly ? params.readOnly(params) : false"
        />
    } @else if (params.multiline) {
        <textarea
            matInput
            #inputElement
            title="{{ params.title }}"
            placeholder="{{ params.placeholder }}"
            tabindex="0"
            [formControl]="formControl"
            [className]="params.classList"
            minlength="{{ params.minLength }}"
            maxlength="{{ params.maxLength }}"
            [appRegexInput]="params.pattern || regExPattern.AllowAllCharacters"
            (focusout)="
                params.onFocusout ? params.onFocusout(formControl) : null
            "
            [readonly]="params.readOnly ? params.readOnly(params) : false"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="params.autoGrowMinRows ?? 1"
            [cdkAutosizeMaxRows]="params.autoGrowMaxRows"
        ></textarea>
    } @else {
        <input
            matInput
            #inputElement
            title="{{ params.title }}"
            placeholder="{{ params.placeholder }}"
            type="{{ params.type }}"
            tabindex="0"
            [formControl]="formControl"
            [className]="params.classList"
            minlength="{{ params.minLength }}"
            maxlength="{{ params.maxLength }}"
            [appRegexInput]="params.pattern || regExPattern.AllowAllCharacters"
            [min]="params.min"
            [max]="params.max"
            (focusout)="
                params.onFocusout ? params.onFocusout(formControl) : null
            "
            [readonly]="params.readOnly ? params.readOnly(params) : false"
        />
    }
    <mat-error>{{ getErrorMessage() }}</mat-error>
</mat-form-field>
